import { useState } from 'react'
import { SavasEkrani } from './savas/SavasEkrani.js'
import { DEMOLAR } from './savas/ornekKurulum.js'

export function Uygulama() {
  const [secili, setSecili] = useState<string | null>(null)
  const [tohum, setTohum] = useState(1)

  const demo = DEMOLAR.find((d) => d.kod === secili)

  if (demo) {
    return (
      <SavasEkrani
        key={`${demo.kod}-${tohum}`}
        kurulum={demo.kurulum}
        tohum={tohum}
        fon={demo.fon}
        tekrar={() => { setTohum((t) => t + 1); setSecili(null) }}
      />
    )
  }

  return (
    <main className="kabuk">
      <h1>KURULTAY</h1>
      <p className="alt">Bozkırın kaderi kurultayda çizilir.</p>
      <p className="not">Bir meslek seç ve savaşa gir.</p>
      <ul className="meslekler">
        {DEMOLAR.map((d) => (
          <li key={d.kod}>
            <button onClick={() => setSecili(d.kod)}>{d.etiket}</button>
          </li>
        ))}
      </ul>
      <p className="ipucu-alt">
        Savaşta <b>1-9</b> tuşlarıyla beceri kullan, <b>Tab</b> ile duruş değiştir.<br />
        Öfke biriktikçe kilitli beceriler açılır.
      </p>
    </main>
  )
}
